import { render } from "./AllFoldersGroups.vue?vue&type=template&id=919c2148"
import script from "./AllFoldersGroups.vue?vue&type=script&lang=js"
export * from "./AllFoldersGroups.vue?vue&type=script&lang=js"

import "./AllFoldersGroups.vue?vue&type=style&index=0&id=919c2148&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__